<template>
    <v-container class="login fill-height" fluid>
        <section class="login__card" aria-labelledby="login-title">
            <img class="login__logo" :src="logo" alt="Granja San Fernando">
            <h1 id="login-title" class="login__title">Iniciar sesión</h1>
            <p class="login__hint">Entra con tu usuario del sistema.</p>

            <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
                <form name="form" novalidate class="form-compact" @submit.prevent="handleSubmit(handleLogin)">
                    <ValidationProvider name="usuario" rules="required" v-slot="{ errors }">
                        <v-text-field v-model.trim="user.username" label="Usuario" name="username"
                            type="text" autocomplete="username" autofocus filled outlined
                            prepend-inner-icon="fas fa-user" hide-details="auto" class="mb-3"
                            :error-messages="errors">
                        </v-text-field>
                    </ValidationProvider>
                    <ValidationProvider name="contraseña" rules="required" v-slot="{ errors }">
                        <v-text-field v-model="user.password" label="Contraseña" name="password"
                            autocomplete="current-password" filled outlined
                            prepend-inner-icon="fas fa-lock" hide-details="auto"
                            :type="showPassword ? 'text' : 'password'"
                            :append-icon="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            :error-messages="errors"
                            @click:append="showPassword = !showPassword">
                        </v-text-field>
                    </ValidationProvider>

                    <p v-if="message" class="login__error error--text" role="alert">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                        <span>{{ message }}</span>
                    </p>

                    <v-btn block large color="primary" type="submit" class="login__submit"
                        :loading="loading">
                        Iniciar sesión
                    </v-btn>
                </form>
            </ValidationObserver>
        </section>
    </v-container>
</template>
<script>
import User from "@/model/user";
import granja from '@/assets/logo_granja.jpeg'
import { safeRedirect } from "@/router/redirect";
import { loginErrorMessage } from "@/views/auth/loginErrors";

export default {
    name: "Login",
    data() {
        return {
            user: new User("", "", ""),
            loading: false,
            showPassword: false,
            logo: granja,
            message: ""
        }
    },
    watch: {
        // el aviso de error no debe quedarse mientras la persona corrige
        'user.username'() { this.message = ""; },
        'user.password'() { this.message = ""; }
    },
    methods: {
        async handleLogin() {
            if (this.loading) return;
            this.loading = true;
            this.message = "";
            try {
                await this.$store.dispatch("auth/login", this.user);
                // Vuelve a la pantalla que se pidió antes de que el guard
                // mandara al login (si había una). `loading` queda activo
                // mientras carga el panel.
                this.$router.replace(safeRedirect(this.$route.query.redirect));
            } catch (error) {
                this.loading = false;
                this.message = loginErrorMessage(error);
            }
        }
    }
}
</script>
<style scoped>
.login {
    justify-content: center;
}
.login__card {
    width: 100%;
    max-width: 400px;
    padding: 32px 28px 28px;
    border: 1px solid var(--app-line);
    border-radius: 12px;
    background: var(--app-surface);
}
.login__logo {
    display: block;
    max-width: 100%;
    height: 112px;
    margin: 0 auto 20px;
    object-fit: contain;
}
/* el logo es un JPEG con fondo blanco: en oscuro va sobre una placa clara en vez de dejar un rectángulo suelto */
.theme--dark .login__logo {
    padding: 8px 16px;
    border-radius: 8px;
    background: #ffffff;
}
.login__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
}
.login__hint {
    margin: 4px 0 24px;
    font-size: 14px;
    color: var(--app-text-muted);
    text-align: center;
}
.login__error {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 16px 0 0;
    font-size: 14px;
}
.login__error i {
    margin-top: 3px;
}
.login__submit {
    margin-top: 20px;
}
@media (max-width: 599px) {
    .login__card {
        padding: 24px 20px 20px;
    }
}
</style>
